// extracted by mini-css-extract-plugin
export default {"component":"LK6gl"};